/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccessDeniedExceptionResponse,
  ApiRequestValidationExceptionResponse,
  BadRequestExceptionResponse,
  InternalServerErrorExceptionResponse,
  NotFoundExceptionResponse,
  SubprojectDetailResponse,
  SubprojectListResponse,
  SubprojectPhotosResponse,
} from '../models/index';
import {
    AccessDeniedExceptionResponseFromJSON,
    AccessDeniedExceptionResponseToJSON,
    ApiRequestValidationExceptionResponseFromJSON,
    ApiRequestValidationExceptionResponseToJSON,
    BadRequestExceptionResponseFromJSON,
    BadRequestExceptionResponseToJSON,
    InternalServerErrorExceptionResponseFromJSON,
    InternalServerErrorExceptionResponseToJSON,
    NotFoundExceptionResponseFromJSON,
    NotFoundExceptionResponseToJSON,
    SubprojectDetailResponseFromJSON,
    SubprojectDetailResponseToJSON,
    SubprojectListResponseFromJSON,
    SubprojectListResponseToJSON,
    SubprojectPhotosResponseFromJSON,
    SubprojectPhotosResponseToJSON,
} from '../models/index';

export interface GetSubprojectByIdRequest {
    id: string;
}

export interface GetSubprojectBySlugRequest {
    slug: string;
}

export interface GetSubprojectPhotosRequest {
    id: string;
}

export interface GetSubprojectsRequest {
    project?: string | null;
    user?: string | null;
    statuses?: Array<GetSubprojectsStatusesEnum>;
    minimalCurrentAmountInCents?: number | null;
    limit?: number;
    offset?: number;
}

/**
 * 
 */
export class SubprojectsApi extends runtime.BaseAPI {

    /**
     */
    async getSubprojectByIdRaw(requestParameters: GetSubprojectByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubprojectDetailResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSubprojectById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/subprojects/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubprojectDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async getSubprojectById(requestParameters: GetSubprojectByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubprojectDetailResponse> {
        const response = await this.getSubprojectByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSubprojectBySlugRaw(requestParameters: GetSubprojectBySlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubprojectDetailResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getSubprojectBySlug().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/subprojects/slug/{slug}`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubprojectDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async getSubprojectBySlug(requestParameters: GetSubprojectBySlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubprojectDetailResponse> {
        const response = await this.getSubprojectBySlugRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSubprojectPhotosRaw(requestParameters: GetSubprojectPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubprojectPhotosResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSubprojectPhotos().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/subprojects/{id}/photos`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubprojectPhotosResponseFromJSON(jsonValue));
    }

    /**
     */
    async getSubprojectPhotos(requestParameters: GetSubprojectPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubprojectPhotosResponse> {
        const response = await this.getSubprojectPhotosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSubprojectsRaw(requestParameters: GetSubprojectsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubprojectListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['project'] != null) {
            queryParameters['project'] = requestParameters['project'];
        }

        if (requestParameters['user'] != null) {
            queryParameters['user'] = requestParameters['user'];
        }

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['minimalCurrentAmountInCents'] != null) {
            queryParameters['minimalCurrentAmountInCents'] = requestParameters['minimalCurrentAmountInCents'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/subprojects`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubprojectListResponseFromJSON(jsonValue));
    }

    /**
     */
    async getSubprojects(requestParameters: GetSubprojectsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubprojectListResponse> {
        const response = await this.getSubprojectsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetSubprojectsStatusesEnum = {
    Draft: 'draft',
    Active: 'active',
    Finished: 'finished',
    Canceled: 'canceled'
} as const;
export type GetSubprojectsStatusesEnum = typeof GetSubprojectsStatusesEnum[keyof typeof GetSubprojectsStatusesEnum];
